<template>
    <div class="s-button">
        
        <b-button
            :class="'btnAll ' + color"
            :size="mySize"
            @click="$emit('action')"
            :style="style"
            :disabled="disabled">

            <b-icon v-if="iconName" :icon="iconName" font-scale="1"></b-icon>
            <b-icon v-else-if="iconName1" :icon="iconConditionVar == true ? iconName1:iconName2" font-scale="1"></b-icon>
            
            {{$t(text)}}

        </b-button>

    </div>
</template>

<script>

import {mapGetters} from 'vuex'

//parametre [action] : dans le parent action à executer

/*
CHARTE DE COULEUR :

color =
    null:               MainColor - par default
    main:               MainColor
    secondary:          SecondaryColor
    mainColorOpposite:  ServexMainColorOpposite
    servex:             ServexBlue
    white:              ServexWhite
    red:                ServexRed
    green:              ServexGreen
    gray:               ServexGray
    
    omain:               Outline-MainColor
    osecondary:          Outline-SecondaryColor
    omainColorOpposite:  Outline-ServexMainColorOpposite
    oservex:             Outline-ServexBlue
    owhite:              Outline-ServexWhite
    ored:                Outline-ServexRed
    ogreen:              Outline-ServexGreen
    ogray:               Outline-ServexGray
*/

export default{
    name: "s-button",
    props: ['value', 'myClass', 'id', 'name', 'text', 'iconName', 'iconConditionVar', 'iconName1', 'iconName2', 'color', 'size', 'myWidth','disabled'],
    data: function() {
        return {
            
        }
    },
    methods:{
        ttt(){
            alert("Allo !!!")
        }
    },
    computed: {
        ...mapGetters(['getAllSize']),
        displayValue: {
            get: function() {
                let sendValue = this.value
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('input', newValue)
            }
        },
        mySize(){
            if(this.size)
            {return this.size;}
            else
            {return this.getAllSize.buttonMenu}
        },
        style(){
            if(this.myWidth)
            {return 'width: ' + this.myWidth + ';'}
            
            return ''
        }
    }
}


</script>

<style lang="scss" scoped>
    @import './button.scss';
    @import './button_color.scss';
    @import './button_colorOutline.scss';
</style>